export interface PaymentInvoiceDeps {
    isInvoiceAvailable: () => boolean;
    isInvoiceOpened: () => boolean;
    createInvoice: (productKey: string) => Promise<{ paymentId: string; invoiceUrl: string } | null>;
    openInvoiceUrl: (url: string) => Promise<string>;
    onPaid: (paymentId: string) => void;
}

export async function openPaymentInvoice(productKey: string, deps: PaymentInvoiceDeps): Promise<void> {
    if (!deps.isInvoiceAvailable() || deps.isInvoiceOpened()) return;
    const result = await deps.createInvoice(productKey);
    if (!result) return;
    const status = await deps.openInvoiceUrl(result.invoiceUrl);
    if (status === 'paid') deps.onPaid(result.paymentId);
}
